module.exports = {
  button: {
    home: "Energy and Device Management Data Board",
    Equipment: "Facility Information",
    waste: "Energy Management",
    Operation: "Operation and maintenance task system",
  },
  // 首页
  HomeScreen: {
    information: {
      Device: "Device implementation information",
      Total: "Total  device",
      tower: "",
      Active: "Active device",
      TotalSpare: "Total  spare",
      Spent: "Spent spare",
      individual: "",
    },
    task: {
      Operation: "Operation and maintenance task",
      Total: "Total  task",
      Monthly: "Monthly total",
      Currentday: "Current day",
      Repair: "Repair",
      Maintenance: "Maintenance",
      Inspection: "Inspection",
      Others: "Others",
      individual: "",
      TaskStatistics: "Task statistics",
      completed: "completed",
      uncompleted: "uncompleted",
    },
    Energy: {
      management: "Energy management",
      Currentday: "Current day",
      Monthlytotal: "Monthly total",
      Recenttotal: "Recent total",
      day: "",
    },
    use: {
      Energy: "Energy use",
      Totalgenerated: "Total generated",
      COreduction: "CO₂ reduction",
      Yearlyview: "Yearly view",
      T: "T",
      January: "January",
      February:'February',
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
    Energystorageinformation:"Energy storage information"

  },
  //   设备
  DeviceInformation: {
    Today: {
      Todayinformation: "Today's information",
      Weather: "Weather",
      Date: "Date",
      Task: "Task statistics",
      Uncompleted: "Uncompleted",
      Completed: "Completed",
    },
    Device: {
      Devicestatistics: "Device statistics",
      Deviceusage: "Device usage",
      Usagerate: "Usage rate",
      Deviceinuse: "Device in use",
      Deactivateddevice: "Deactivated device",
      tower: "",
      piece: "",
      Inspectionplan: "Inspection/Maintenance plan",
      Cycle: "Cycle",
    },
    alert: {
      Realtimealert: "Real-time alert",
      Time: "Time",
      Type: "Type",
      Device: "Device",
      currentyear: "Number of failures in the current year",
      Times: "Times",
    },
    information: {
      Deviceinformation: "Device information",
      Operation: "Operation",
      Name: "Name",
      Type: "Type",
      ID: "ID",
      inspection: "Monthly inspection statistics",
      maintenance: "Monthly maintenance statistics",
      All: "All",
      Uncompleted: "Uncompleted",
      Completed: "Completed",
    },
  },
  //   废危
  HazardousWaste: {
    Setvalue: "Set value",
    Currentvalue: "Current value",
    time: "Continuous evaporation time",
    Runningtime: "Running time",
    dischargetime: "Concentration discharge time",
    temperaturesetvalue: "Condensate temperature set value",
    temperature: "Condensate temperature",
    alarm: "Exhaust pressure alarm",
    settingvalue: "Refrigerant pressure setting value",
    Refrigerantpressure: "Refrigerant pressure",
    Wastefeedtime: "Waste feed time",
    Exhaustpressuresetvalue: "Exhaust pressure set value",
    Exhaustpressure: "Exhaust pressure",
    Cleaningtime: "Cleaning time",
    Evaporationsetvalue: "Evaporation tank pressure set value",
    Evaporationtankpressure: "Evaporation tank pressure",
    Concentrationtime: "Concentration time",
    EnergyInformation:"Energy storage information",
    batteryStatus:"Current battery status",
    Charging:"Charging",
    discharge:'Discharging',
    idle:"Idle",
    Shutdown:"Shutdown",
    electricData:"electric data",
    yuan:"yuan",
    chargingpower:"Total charging power",
    dischargepower:"Total discharge power",
    electricitysavings:"Electricity savings",
    datastatistics:"Recent data statistics",
    Chargingcapacity:"Charging capacity",
    Dischargecapacity:"Discharge capacity",
    dischargingsituation:"Charging and discharging situation",
    price:'Time period electricity price',
    saving:'Energy saving',
    EnergyStorageCabinet:"Cabinet"
  },
  //   运维
  Operationsystem: {
    analysis: {
      Platformanalysis: "Platform condition analysis",
      Activedevice: "Active device",
      Disableddevice: "Disabled device",
      Maintenance: "Maintenance device",
      Devicenumber: "Device number",
      Monthlymaintenance: "Monthly maintenance status",
      Totaltasks: "Total tasks",
      individual: "",
      Rateofcompletion: "Completion Rate",
      Timelinessratio: "Timely Rate",
      Completed: "Completed",
      Delayedcompletion: "Delayed completion",
      tower: "",
      WorkOrderType:'Work Order Type',
      WorkOrdernNumber:'Work Order Number',
      WorkOrderStatus:'Work Order Status',
      TaskDate:'Task Date'
    },
    table: {
      Tasktypestatistics: "Task type statistics",
      Planstatistics: "Task type statistics",
      Repair: "Repair",
      Maintenance: "Maintenance",
      Inspection: "Inspection",
    },
    Taskanalysis: {
      Taskanalysis: "Task analysis",
      Repair: "REP",
      Maintenance: "MAI",
      Inspection: "INS",
      RepairE: "Repair",
      MaintenanceE: "Maintenance",
      InspectionE: "Inspection",
      Orderprocessing: "Order processing",
      Neworder: "New order",
      Examineorder: "Examine order",
      Completeorder: "Complete order",
      Totaltoday: "Total today's order",
      area: "Situation of factory area",
      Name: "Name",
      device: "Number of device",
      type: "Number of device type",
    },
  },
};